<template>
  <div class="container">
    <div class="hcontainer" style="z-index: 100; position: fixed; margin-top: -2px">
      <van-sticky>
        <van-row class="top_dh">
          <van-col span="1"></van-col>
          <van-col span="3"><van-icon size="2em" name="https://images.nshdcc.com/nshd/images/logo1.png" /></van-col>
          <van-col span="17"><b>广州南沙弘达仓储有限公司</b></van-col>
          <van-col span="3"><van-icon :name="name" size="24" @click="showPopup" /></van-col>
        </van-row>

        <van-sidebar v-if="show" style="width: 100%" v-model="active" @change="onChange">
          <van-sidebar-item class="vlb" title="首页" to="/" />
          <van-sidebar-item class="vlb" title="公司简介" to="/home" />
          <van-sidebar-item class="vlb" title="最新动态" to="/NewsList" />
          <van-sidebar-item class="vlb" title="司机帮助文档" to="/HelpList" />
          <van-sidebar-item class="vlb" title="联系方式" to="/contact" />
        </van-sidebar>
      </van-sticky>
    </div>
    <div style="z-index: 2; margin-top: 1.25rem"><router-view /></div>
    <div class="icp" style="z-index: 2">
      <p>Copyright 2023 - {{ nowTime }} 广州南沙弘达仓储有限公司.</p>
      <p>All Rights Reserved.</p>
      <p><a target="_blank" href="https://beian.miit.gov.cn/">粤ICP备2021108032号-3</a></p>
    </div>


    <van-overlay :show="show" @click="showPopup" lock-scroll="true" z-index="50" />
    <van-back-top />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";

export default {
  setup() {
    const active = ref(0);
    const show = ref(false);
    const nowTime = ref("");
    const name = ref("wap-nav");

    const formateDate = (date) => {
      const time = new Date(date);
      const year = time.getFullYear();
      return year;
    };
    onMounted(() => {
      var calc = function () {
        var width =
          document.documentElement.clientWidth ||
          document.body.clientWidth ||
          window.innerWidth;
        var rem = width / 10;

        rem = document.documentElement.clientWidth > 750 ? 37.5 : rem;
        document.documentElement.style.fontSize = rem + "px";
        //alert(rem);
      };
      calc();
      window.addEventListener("resize", calc);
    });
    setInterval(() => {
      nowTime.value = formateDate(new Date());
    });
    const showPopup = () => {
      show.value = !show.value;
      if (show.value) {
        name.value = "arrow-up";
      } else {
        name.value = "wap-nav";
      }
    };
    const onChange = () => {
      show.value = !show.value;
      if (show.value) {
        name.value = "arrow-up";
      } else {
        name.value = "wap-nav";
      }
    };

    return {
      active,
      show,
      showPopup,
      onChange,
      nowTime,
      name,
    };
  },
};
</script>



<style>
/* 该css文件是处理一些全局的基础样式文件 */
@import url("https://fonts.googleapis.com/css2?family=Exo:wght@600&display=swap");

* {
  /* 清除浏览器的默认内外边距 */
  margin: 0px;
  padding: 0px;
  /* 移动端适配核心点
        1.不允许网页出现横向滚动条
        2.页面盛满屏幕，盒子宽度与屏幕一致 100%
        3.让盒子的内容宽高width/height包含padding与border，避免出现横向滚动条  
    */
  box-sizing: border-box;
}

body {
  /* 移动端默认字体一般是12px */
  /* font-size: 12px; */
  width: 100vw;
  min-height: 100vh;
  font-family: "Exo", Arial, sans-serif;
  color: #000;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

li {
  list-style: none;
}

img {
  vertical-align: middle;
  /* 图片居中 */
}

a {
  color: #000;
  /* 取消a标签默认下划线 */
  text-decoration: none;
  /* 移动端点击a链接出现蓝色背景问题解决 */
  -webkit-tap-highlight-color: transparent;
}

input {
  border: 0 none;
  outline-style: none;
  /*取消内边框*/
}

/* 清除浮动，解决margin-top塌陷 */
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.celarfix {
  zoom: 1;
}



html {
  overflow-y: scroll;
}

:root {
  overflow-y: auto;
  overflow-x: hidden;
}

:root body {
  position: absolute;
}

body {
  width: 100vw;
  overflow: hidden;
}

.top_dh {
  background-color: aliceblue;
  font-size: 0.42rem;
  line-height: 1.2rem;
  border-bottom: 1px #ccc solid;

}

.vlb {
  border-bottom: 1px #ccc solid;
  font-size: 0.4rem;
  font-weight: bold;
}

.icp {
  display: flex;
  flex-direction: column;
  font-size: 0.35rem;
  background-color: #e5e1e1;
  justify-content: center;
  align-items: center;
  line-height: 0.6rem;
  padding: 0.3rem;
  text-align: center;
}

:root:root {
  --van-tabs-bottom-bar-color: #d45c4e;
  --van-tab-font-size: 0.45rem;
  --van-tabs-bottom-bar-width: 1.62rem;
}

/* 手机端样式 */
@media (max-width: 767px) {
  .container {
    width: 100%;
    border: #f8f6f6 1px solid;
  }

  .hcontainer {
    width: 100%;
  }
}

/* 电脑端样式 */
@media (min-width: 768px) {
  .container {
    width: 750px;
    margin: 0 auto;
    border: #f8f6f6 1px solid;
  }

  .hcontainer {
    width: 750px;
  }

  .top_dh{
    width: 750px;
  }
}
</style>
